<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <grid-evaluacion
                :key="gridDocumento"
                :rowsTable="rowsTable"
                :contratoId="contratoId"
              ></grid-evaluacion>
              <!-- <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text">En construcción</v-toolbar-title>
            </v-toolbar> -->
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridEvaluacion from "@/modules/aplicacion/views/seleccion/evaluacion/GridEvaluacion.vue";

export default {
  name: "menu-sub-proceso-evaluacion",

  components: {
    GridEvaluacion,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      ultimoAcuerdo: 10,
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    filterDoc() {
      this.filter = true;
    },
  },
};
</script>
